import type { Resident } from '@lmc/ts-common'
import { Input } from 'antd'
import React from 'react'
import type FormStateType from '../../FormState.type'

const { TextArea } = Input

type PropTypes = {
  formState: FormStateType
  resident: Resident
  setFormState: (newState: object) => void
}

export const ConfirmStep = ({
  formState,
  setFormState,
  resident
}: PropTypes) => (
  <div className="signature-modal-vertial-center">
    <p style={styles.signedBy}>Signed by:</p>
    <img src={formState.imageURL} alt="signature" style={styles.signature} />
    <p style={styles.name}>
      {formState.name
        ? `${formState.name} (${formState.relationship})`
        : `${resident.name.first} ${resident.name.last}`}
    </p>
    {formState.reason && <p>{formState.reason}</p>}
    <p style={styles.commentContainer}>Additional Comments</p>
    <TextArea
      value={formState.comment}
      onChange={(e) => setFormState({ comment: e.target.value })}
    />
  </div>
)

const styles = {
  signature: {
    display: 'block',
    paddingBottom: 12,
    width: '150px'
  },
  name: { color: '#A1A1A1' },
  commentContainer: { paddingTop: 24, fontSize: 16 },
  signedBy: { fontSize: 16, fontWeight: 700 }
}

export default ConfirmStep
